<template>
  <main-content-layout
    :title="$gettext('MSG_EMAIL_SMS')"
    :buttonTitle="$gettext('SEND')"
    :actionButton="
      () => {
        showSendModal();
      }
    "
    buttonIconName="list"
  >
    <div class="tw-p-5">
      <jt-data-table
        :api-mode="false"
        :data="dataGrid.registros"
        :fields="dataTableGrid.columns"
        :is-paginated="false"
        :title="titleTeble"
        row-buttons
        @action-button="actionButton"
      >
        <template #header="{ props }">
          <q-tr :props="props" class="table-header">
            <q-th
              v-for="col in props.cols.filter(
                (col) => col.render != 'HIDDEN' && col.field != 'message'
              )"
              :key="col.name"
              :props="props"
            >
              <div style="display: flex; justify-content: center">
                {{ col.label }}
              </div>
            </q-th>
            <q-th auto-width />
          </q-tr>
        </template>

        <template #body="{ props }">
          <q-tr class="send-sms-row text-left">
            <q-td
              v-for="col in props.cols.filter(
                (col) => col.render != 'HIDDEN' && col.field != 'message'
              )"
              :key="col.name"
              :props="props"
            >
              <span v-if="col.field == 'title'" class="cell-values">
                <div class="send-sms-title">{{ getValue(props.row, 'title') }}</div>
                <div v-show="!props.expand" class="send-sms-summary">{{ getSummary(getValue(props.row, 'message')) }}</div>
              </span>
              <span v-else-if="col.field == 'isEmail'" class="cell-values">
                <span v-if="props.row._isHistory">
                  {{ getLabelForItem(props.row) }}
                </span>
                <span v-else-if="getValue(props.row, 'isEmail')">
                  {{ $gettext("EMAIL") }}
                </span>
                <span v-else-if="getValue(props.row, 'tipo')">
                  {{ getValue(props.row, 'tipo') }}
                </span>
                <span v-else>
                  {{ $gettext("SMS") }}
                </span>
              </span>
              <span v-else-if="col.field == 'date'" class="cell-values">
                <div style="font-size: 14px">
                  {{ getDatePart(getValue(props.row, 'date')) || '' }}
                </div>
                <div class="send-sms-time">
                  {{ getTimePart(getValue(props.row, 'date')) || '' }}
                </div>
              </span>
              <span v-else-if="col.render != 'HIDDEN'" class="cell-values">
                {{ getDisplayValue(col.field, props.row) }}
              </span>
            </q-td>
            <q-td auto-width>
              <q-btn
                flat
                dense
                round
                color="primary"
                :icon="props.expand ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
                @click="props.expand = !props.expand"
              />
            </q-td>
          </q-tr>
          <q-tr v-show="props.expand" class="send-sms-detail-row" :props="props">
            <q-td
              v-for="(col, idx) in props.cols.filter(
                (col) => col.render != 'HIDDEN' && col.field != 'message'
              )"
              :key="col.name"
            >
              <div v-if="idx === 0" class="send-sms-detail-content">
                <div v-if="props.row._isHistory" class="send-sms-detail-channel">
                  <q-icon
                    :name="getIconForItem(props.row)"
                    size="sm"
                    :style="{ color: getColorForItem(props.row) }"
                  />
                </div>
                <div v-else class="send-sms-detail-channel">
                  <q-icon name="message" size="sm" />
                </div>
              </div>
              <div v-else-if="idx === 1" class="send-sms-detail-status">
                <span
                  v-if="props.row._isHistory && props.row.statusCode"
                  class="send-sms-status-dot"
                  :style="{ backgroundColor: getStatusColor(props.row.statusCode) }"
                />
                {{ props.row._isHistory && props.row.status ? props.row.status : '' }}
              </div>
              <div v-else-if="idx === 2" class="send-sms-detail-message">
                {{ getCleanMessageText(getValue(props.row, 'message')) }}
              </div>
            </q-td>
            <q-td auto-width />
          </q-tr>
        </template>
      </jt-data-table>
    </div>
    <modal
      ref="sendModal"
      v-if="flModalShow"
      :show="flModalShow"
      :forms="forms"
      :label="this.$gettext('SEND')"
      @action-button="actionButton"
    />
  </main-content-layout>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import SendEmailSmsController from './SendEmailSmsController'
import moment from 'moment'
import { JtCrud, JtDataTable } from 'jtech-webcomps'
import { validate } from 'vue-convenia-util'
import { JtechMessage } from 'src/plugins/system.messages'
import { repository } from 'jtech'
import { formatDateTimeLocal } from 'src/shared/utils/dateUtils.js'
import { getChannelColor, getChannelIcon, getChannelLabel } from 'src/modules/concession/messaging/utils/channelMappings.js'
import { dispatchStatus } from 'src/shared/inf-tabela-descricao/DispatchStatus.enum.js'
import MainContentLayout from '../../Layout/MainContentLayout.vue'
const { modal } = JtCrud

@Component({
  name: 'SendEmailSms',
  components: {
    modal,
    JtDataTable,
    MainContentLayout
  },
  props: {
    consumerUnit: String,
    protocol: String
  }
})
class SendEmailSms extends Vue {
  controllerRequest = SendEmailSmsController.getInstance();
  moment = moment;
  validate = validate;
  data = [];
  datatable = {};
  nmInterface = 'communicationManifest.historico'

  forms = null;
  flModalShow = false;
  historyData = [];

  get dataGrid () {
    return {
      registros: [...this.data, ...this.historyData]
    }
  }

  get dataTableGrid () {
    return this.datatable
  }

  async mounted () {
    this.datatable = await this.controllerRequest.loadDatatable()
    await this.loadFiles()
    await this.loadCommunicationHistory()
  }

  async loadFiles () {
    const result = await this.controllerRequest.loadDatatableModel({
      consumerUnit: parseInt(this.consumerUnit, 10)
    })

    const registros = (result?.registros || result || [])
    const items = Array.isArray(registros) ? registros : []
    this.data = items.map(item => this.normalizeItem(item, false))
  }

  async loadCommunicationHistory () {
    try {
      const resolved = await repository.resolveDatatableModel(this.nmInterface, {
        grid: 'resultado',
        consumerUnit: parseInt(this.consumerUnit, 10)
      })

      let historyItems = []
      if (Array.isArray(resolved)) {
        historyItems = resolved
      } else if (resolved?.registros && Array.isArray(resolved.registros)) {
        historyItems = resolved.registros
      }

      this.historyData = historyItems.map(item => this.normalizeItem(item, true))
    } catch (error) {
      console.error('Erro ao carregar histórico de comunicações:', error)
    }
  }

  normalizeItem (item, isHistory) {
    if (isHistory) {
      return {
        id: item.id,
        title: item.subject || item.assunto,
        message: item.message || item.mensagem,
        date: item.sentAt,
        contact: item.recipient,
        isEmail: item.channelType === 50460001,
        tipo: item.channelType_nmDescricao,
        campaign: item.campaign_name,
        user: item.responsible || item.createdBy_nmUsuario,
        status: item.dispatchStatus_nmDescricao,
        statusCode: item.dispatchStatus,
        _isHistory: true,
        _source: 'history'
      }
    } else {
      return {
        ...item,
        tipo: item.isEmail ? 'Email' : 'SMS',
        campaign: null,
        user: null,
        status: null,
        statusCode: null,
        _isHistory: false,
        _source: 'sendEmailSms'
      }
    }
  }

  async showSendModal () {
    this.forms = await this.controllerRequest.loadForm()
    this.flModalShow = true
  }

  async actionButton (button, params) {
    if (button.name == 'btGravar') {
      if (params.isEmail && this.validate.isEmail(params.contact)) {
        await this.controllerRequest.createSendEmailSms({
          consumerUnit: this.consumerUnit,
          ...params
        })
        this.flModalShow = false
        this.loadFiles()
      } else {
        JtechMessage.error(this.$gettext('INVALID_EMAIL_MESSAGE'))
      }
    }
  }

  getValue (row, key) {
    if (!row) return ''
    return row[key] || ''
  }

  getDisplayValue (field, row) {
    const value = this.getValue(row, field)

    return value || '-'
  }

  getSummary (message) {
    if (!message) return ''
    return this.toSingleLineText(this.getCleanMessageText(message)).substring(0, 140)
  }

  getDatePart (value) {
    if (!value) return ''
    const formatted = formatDateTimeLocal(value)
    if (formatted) {
      return formatted.split(' ')[0]
    }
    return moment(value, 'DD-MM-YYYY HH:mm:ss').format('DD/MM/YYYY')
  }

  getTimePart (value) {
    if (!value) return ''
    const formatted = formatDateTimeLocal(value)
    if (formatted) {
      const timePart = formatted.split(' ')[1]?.trim() || ''
      const [hours, minutes] = timePart.split(':')
      return `${hours}:${minutes}`
    }
    return moment(value, 'DD-MM-YYYY HH:mm:ss').format('HH:mm')
  }

  stripHtml (value) {
    if (!value) return ''
    return String(value)
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/p>/gi, '\n')
      .replace(/<li>/gi, '- ')
      .replace(/<[^>]+>/g, ' ')
      .replace(/\s+\n/g, '\n')
      .replace(/\n\s+/g, '\n')
      .replace(/\n{3,}/g, '\n\n')
      .replace(/\s{2,}/g, ' ')
      .trim()
  }

  sanitizeMessageHtml (value) {
    if (!value) return ''
    return String(value)
      .replace(/<p>(?:\s|&nbsp;|<br\s*\/?>)*<\/p>/gi, '')
      .replace(/<li>(?:\s|&nbsp;|<p>(?:\s|&nbsp;|<br\s*\/?>)*<\/p>)*<\/li>/gi, '')
      .replace(/<ul>(?:\s|&nbsp;)*<\/ul>/gi, '')
      .trim()
  }

  toSingleLineText (value) {
    if (!value) return ''
    return this.stripHtml(value)
      .replace(/\s+/g, ' ')
      .trim()
  }

  getCleanMessageText (message) {
    const sanitized = this.sanitizeMessageHtml(message)
    return this.stripHtml(sanitized)
  }

  getChannelTypeId (item) {
    if (!item) return null
    const value = item.channelType || (item.isEmail ? 50460001 : null)
    if (value === undefined || value === null || value === '') return null
    const parsed = Number(value)
    return Number.isNaN(parsed) ? null : parsed
  }

  getIconForItem (item) {
    return getChannelIcon(this.getChannelTypeId(item))
  }

  getColorForItem (item) {
    return getChannelColor(this.getChannelTypeId(item))
  }

  getLabelForItem (item) {
    return getChannelLabel(this.getChannelTypeId(item)) || item?.tipo || ''
  }

  getStatusColor (statusCode) {
    if (!statusCode) return '#999999'
    const statuses = dispatchStatus()

    if (statusCode === statuses.SUCCESS.key) return '#006233' // green
    if (statusCode === statuses.FAILED.key) return '#cc1717' // red
    if (statusCode === statuses.BOUNCED.key) return '#cc1717' // red
    if (statusCode === statuses.QUEUED.key) return '#0062a9' // blue
    if (statusCode === statuses.PROCESSING.key) return '#d18e4b' // orange
    if (statusCode === statuses.NOT_SENT.key) return '#999999' // gray

    return '#999999' // gray
  }
}
export default SendEmailSms
</script>
<style lang="stylus" scoped>
.send-sms-row
  .send-sms-title
    font-weight: 600

  .send-sms-summary
    color: #5f6368
    font-size: 12px
    margin-top: 4px
    text-align: left

  .send-sms-time
    color: #5f6368
    font-size: 12px

.send-sms-detail-row
  background-color: #f8fafc

.send-sms-detail-content
  display: block
  padding: 8px 0

.send-sms-detail-channel
  display: flex
  align-items: center
  gap: 6px

.send-sms-detail-status
  display: flex
  align-items: center
  gap: 6px
  color: #374151
  font-size: 12px

.send-sms-status-dot
  width: 10px
  height: 10px
  border-radius: 50%
  display: inline-block
  flex-shrink: 0

.send-sms-detail-message
  color: #1f2937
  white-space: pre-wrap
  overflow-wrap: anywhere
  word-break: break-word
  line-height: 1.35
  text-align: left
  min-width: 0
</style>
